export const COLORS = {
  background: {
    light: "hsla(0, 100%, 100%, 1)",
    dark: "hsla(0, 0%, 7%, 1)",
  },
  foreground: {
    light: "hsla(195, 15%, 95%, 1)",
    dark: "hsla(0, 0%, 9%, 1)",
  },
  text: {
    light: "hsla(0, 0%, 0%,1)",
    dark: "hsla(0, 0%, 70%,1)",
  },
  headingFont: {
    light: "#1B1C20",
    dark: "#F0F3F4",
  },
  primary: {
    light: "hsla(0, 90%, 72%, 1)",
    dark: "hsla(4, 100%, 82%, 1)",
  },
  secondary: {
    light: "hsla(269, 100%, 80%, 1)",
    dark: "hsla(269, 71%, 83%, 1)",
  },
  // Grays, scaling from most-noticeable to least-noticeable
  gray1: {
    light: "hsl(0, 0%, 50%)",
    dark: "hsl(0, 0%, 50%)",
  },
  gray2: {
    light: "hsl(0, 0%, 65%)",
    dark: "hsl(0, 0%, 35%)",
  },
  gray3: {
    light: "hsla(0, 0%, 80%, 1)",
    dark: "hsla(0, 0%, 20%,1)",
  },
  editorPreview: {
    light: "#fff",
    dark: "#414141",
  },
}

export const COLOR_MODE_KEY = "color-mode"
export const INITIAL_COLOR_MODE_CSS_PROP = "--initial-color-mode"
